module.exports = __webpack_public_path__ + "static/media/blue-edit.c813462c.svg";